import { Chip } from '@/components/reusables/dashboard/Chip';
import TableHeader from '@/components/reusables/dashboard/TableHeader';
import TableSkeleton from '@/components/reusables/TableSkeleton';
import { useFetchProductsPaginated } from '@/hooks/productManagementHooks';
import useAuthStore from '@/store/authStore';
import { capitalize, truncate } from '@/utils/strings';
import { Box } from 'lucide-react';
import { useNavigate } from 'react-router';

const RecentProducts = () => {
  const userProfile = useAuthStore((state) => state.userProfile);
  const userRole = userProfile?.role;
  const navigate = useNavigate();

  let productsUrl = ``;
  if (userRole) {
    switch (userRole) {
      case 'OWNER':
        productsUrl = '/owner/vendors';
        break;
      case 'MANAGER':
        productsUrl = '/manager/vendors';
        break;

      default:
        productsUrl = '/404';
    }
  }

  const { data: theProducts, isLoading, isFetching } = useFetchProductsPaginated();
  const allProducts = theProducts?.data ?? [];

  return (
    <>
      {isLoading || isFetching ? (
        <TableSkeleton rows={6} cols={6} showHeader={true} />
      ) : (
        <div className="d-full-card-wrap">
          <TableHeader
            title="Recent Products"
            titleIcon={Box}
            onViewAllButtonClick={() => navigate(productsUrl)}
          />
          <div className="data-table-wrap">
            <div className="static-table-fix">
              <table className="data-table">
                <thead>
                  <tr>
                    <th>Vendor</th>
                    <th>Product Name</th>
                    <th>Style</th>
                    <th>Color</th>
                    <th>Product Cost</th>
                    <th>Formula</th>
                    <th>Markup</th>
                    <th>Retail Price</th>
                    <th>Status</th>
                    <th>Discontinued</th>
                  </tr>
                </thead>
                <tbody>
                  {allProducts && allProducts.length > 0 ? (
                    allProducts.map((product: any) => (
                      <tr key={product?.id}>
                        <td>{product?.vendor?.name ? product?.vendor?.name : '----'}</td>
                        <td>{product?.name ? truncate(product?.name) : '----'}</td>
                        <td>{product?.style ? truncate(product?.style) : '----'}</td>
                        <td>{product?.color ? product?.color : '----'}</td>
                        <td>{product?.productCost ? '$' + product?.productCost : '----'}</td>
                        <td>{product?.pricingFormula ? product?.pricingFormula : '----'}</td>
                        <td>{product?.markup ? product?.markup + '%' : '----'}</td>
                        <td>{product?.retailPrice ? '$' + product?.retailPrice : '----'}</td>
                        <td>
                          {(() => {
                            const status = product?.status
                              ? product?.status === 'In Stock'
                                ? 'In Stock'
                                : 'On Sale'
                              : '----';
                            const variant = status === 'In Stock' ? 'active' : 'warning';

                            return status ? (
                              <Chip label={capitalize(status)} variant={variant} />
                            ) : (
                              '----'
                            );
                          })()}
                        </td>
                        <td>
                          {(() => {
                            const discontinued = product?.discontinued;

                            if (discontinued === null || discontinued === undefined) return '----';

                            const label = discontinued ? 'Yes' : 'No';
                            const variant = discontinued ? 'danger' : 'active';

                            return <Chip label={label} variant={variant} />;
                          })()}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={12} className="text-center">
                        No results
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default RecentProducts;
